import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSend = (props, ref) => (React.createElement("svg", { width: 24, height: 24, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M792-443 176-183q-20 8-38-3.5T120-220v-520q0-22 18-33.5t38-3.5l616 260q25 11 25 37t-25 37M200-280l474-200-474-200v140l240 60-240 60zm0 0v-400z" })));
const ForwardRef = forwardRef(SvgSend);
const Memo = memo(ForwardRef);
export default Memo;
